// extracted by css-extract-rspack-plugin
export default {"MetadataFooterLoadingContainer":"MetadataFooterLoading-module__MetadataFooterLoadingContainer__miL72Cv"};